import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';

function LegalNav() {
  const location = useLocation();
  
  return (
    <div className="flex gap-4 mb-8">
      <Link 
        to="/legal/terms"
        className={`px-4 py-2 rounded-lg ${
          location.pathname === '/legal/terms'
            ? 'bg-gray-custom-700 text-white'
            : 'text-gray-custom-400 hover:bg-gray-custom-800'
        }`}
      >
        Terms of Service
      </Link>
      <Link 
        to="/legal/privacy"
        className={`px-4 py-2 rounded-lg ${
          location.pathname === '/legal/privacy'
            ? 'bg-gray-custom-700 text-white'
            : 'text-gray-custom-400 hover:bg-gray-custom-800'
        }`}
      >
        Privacy Policy
      </Link>
    </div>
  );
}

function Terms() {
  return (
    <div className="prose prose-invert max-w-none">
      <h1>Terms of Service</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using Overseer, you agree to be bound by these Terms of Service.</p>

      <h2>2. Description of Service</h2>
      <p>Overseer is a Discord bot that provides moderation, utility, and economy features for Discord servers.</p>

      <h2>3. User Responsibilities</h2>
      <p>Users are responsible for:</p>
      <ul>
        <li>Complying with Discord's Terms of Service</li>
        <li>Using the bot in accordance with these terms</li>
        <li>Maintaining the security of their server</li>
      </ul>

      <h2>4. Premium Features</h2>
      <p>Premium features are available through a subscription service. Subscriptions can be cancelled at any time.</p>

      <h2>5. Limitation of Liability</h2>
      <p>Overseer is provided "as is" without any warranties of any kind.</p>
    </div>
  );
}

function Privacy() {
  return (
    <div className="prose prose-invert max-w-none">
      <h1>Privacy Policy</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>

      <h2>1. Information We Collect</h2>
      <p>We collect:</p>
      <ul>
        <li>Server IDs and basic server information</li>
        <li>User IDs and basic user information</li>
        <li>Command usage data</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <p>We use the collected information to:</p>
      <ul>
        <li>Provide and improve our services</li>
        <li>Monitor bot performance</li>
        <li>Prevent abuse</li>
      </ul>

      <h2>3. Data Storage</h2>
      <p>All data is stored securely and is only accessible to authorized personnel.</p>

      <h2>4. Data Deletion</h2>
      <p>Users can request data deletion by contacting our support team.</p>
    </div>
  );
}

function Legal() {
  return (
    <div>
      <div className="container-custom py-24">
        <LegalNav />
        <Routes>
          <Route path="terms" element={<Terms />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="*" element={<Terms />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default Legal; 